@import 'styles/mixins';
@import 'styles/variables';

.table {
  width: 99%; // table width rendering bug
  table-layout: fixed;
}

.headerColumn {
  width: 34%;
}

.contentColumn {
  width: 66%;
}

.row {
  border-bottom: 1px solid $gray-10;
  &:first-child {
    .rowContent,
    .rowHeading {
      padding-top: 0;
    }
  }
  &:last-child {
    border-bottom: none;
    .rowContent,
    .rowHeading {
      padding-bottom: 0;
    }
  }

  &.topAlign {
    .rowHeading {
      display: flex;
    }
  }
}

.groupRow {
  @include line-clamp;
  @include ui-md-text;
}

.groupRow + .groupRow {
  margin-top: 12px;
}

.rowHeading {
  @include ui-sm-text;
  color: $gray-70;
}

.rowContent {
  @include ui-md-text;
  color: $gray-90;
  text-align: right;
  text-overflow: ellipsis;
  overflow: hidden;
}

.rowContent,
.rowHeading {
  padding: 11px 0;
}
